module.exports = __webpack_public_path__ + "img/13-1.6eee7f65.jpg";